module.exports = __webpack_public_path__ + "img/gg-15.prt.9629c4e8.jpg";